import { render, staticRenderFns } from "./OrganismProjectPortfolio.vue?vue&type=template&id=44fa70af&"
import script from "./OrganismProjectPortfolio.vue?vue&type=script&lang=js&"
export * from "./OrganismProjectPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./OrganismProjectPortfolio.vue?vue&type=style&index=0&id=44fa70af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsPortfolioAtomProjectPortfolio: require('/app/components/atoms/portfolio/AtomProjectPortfolio.vue').default,MoleculesPortfolioMoleculeProjectPortfolio: require('/app/components/molecules/portfolio/MoleculeProjectPortfolio.vue').default,MoleculesCommonMoleculeGoogleMap: require('/app/components/molecules/common/MoleculeGoogleMap.vue').default})
